<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="items"
          class="transparent"
          hide-default-footer
          disable-pagination
          show-select
          v-model="selectedItems"
          item-key="id"
        />
      </v-col>
      <v-col cols="12" align="center">
        <TextButton
          :loading="loading"
          :disabled="selectedItems.length === 0 || loading"
          @click="handleDesasignacionEquipo()"
          >Desasignar equipo seleccionado</TextButton
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import IconButton from '@/components/base/IconButton.vue'
import TextButton from '@/components/base/TextButton.vue'
import EliminarEquipoAsignadoUsecase from '@/modules/equipamiento/application/EliminarEquipoAsignado.usecase'
import EquipoAsignadoApiRepository from '@/modules/equipamiento/infrastructure/EquipoAsignadoApi.repository'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    IconButton,
    TextButton,
  },

  props: {
    asignacionEquipo: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      headers: [
        { text: 'Item', value: 'item', align: 'center' },
        { text: 'Tipo equipo', value: 'tipoEquipo', align: 'center' },
        { text: 'Estatus', value: 'estatus', align: 'center' },
        { text: 'Años vigencia', value: 'aniosVigencia', align: 'center' },
        { text: 'Fecha de fabricación', value: 'fechaFabricacion', align: 'center' },
      ],
      selectedItems: [],
      loading: false,
    }
  },

  computed: {
    ...mapGetters('asignacionEquipo', { asignacionesEquipo: 'getAsignacionesEquipo' }),

    items() {
      return this.asignacionEquipo.equipoAsignado.map((equipo) => ({
        id: equipo.id,
        tipoEquipo: equipo.Equipo?.CatItem?.CatTipoItem?.title ?? '',
        item: equipo.Equipo?.CatItem?.item ?? '',
        estatus: equipo.Equipo?.CatEstatus?.title ?? equipo.CatEstatus?.title ?? '',
        aniosVigencia:
          equipo.Equipo?.CatItem?.aniosVigencia ?? equipo.Equipo?.aniosVigencia ?? equipo.aniosVigencia ?? '',
        fechaFabricacion: equipo.Equipo?.CatItem?.fechaFabricacion ?? equipo.Equipo?.fechaFabricacion ?? '',
      }))
    },
  },

  methods: {
    ...mapActions('asignacionEquipo', ['fetchAsignacionEquipoByPersonal']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapMutations('dialog', ['CLOSE_DIALOG']),

    async handleDesasignacionEquipo() {
      try {
        this.loading = true

        await new EliminarEquipoAsignadoUsecase(EquipoAsignadoApiRepository).execute(
          this.asignacionEquipo,
          this.selectedItems.map((item) => item.id)
        )
        await this.fetchAsignacionEquipoByPersonal(this.asignacionEquipo.fk_idPersonal)

        this.CLOSE_DIALOG()
        this.SET_SNACKBAR_MESSAGE('Equipo desasignado correctamente.')
      } catch {
        this.SET_SNACKBAR_MESSAGE('No fue posible desasignar el equipo.')
      } finally {
        this.loading = false
        this.selectedItems = []
      }
    },
  },
}
</script>
